import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { getPublicSiteOrigin } from '../constants/publicUrl';

const registerCommercialAgentFn = httpsCallable(functions, 'registerCommercialAgent');
const resolveAgentCodeFn = httpsCallable(functions, 'resolveAgentCode');
const getMyCommercialAgentDashboardFn = httpsCallable(functions, 'getMyCommercialAgentDashboard');
const updateCommercialAgentMomoFn = httpsCallable(functions, 'updateCommercialAgentMomo');
const requestAgentPayoutFn = httpsCallable(functions, 'requestAgentPayout');
const moderateCommercialAgentFn = httpsCallable(functions, 'moderateCommercialAgent');
const stampRegistrationAgentFn = httpsCallable(functions, 'stampRegistrationAgent');

export async function registerCommercialAgent(payload) {
  const { data } = await registerCommercialAgentFn(payload);
  return data;
}

export async function resolveAgentCode(code) {
  const { data } = await resolveAgentCodeFn({ code });
  return data;
}

export async function getMyCommercialAgentDashboard(limit = 30) {
  const { data } = await getMyCommercialAgentDashboardFn({ limit });
  return data;
}

export async function updateCommercialAgentMomo(payload) {
  const { data } = await updateCommercialAgentMomoFn(payload);
  return data;
}

export async function requestAgentPayout(payload) {
  const { data } = await requestAgentPayoutFn(payload);
  return data;
}

export async function moderateCommercialAgent(payload) {
  const { data } = await moderateCommercialAgentFn(payload);
  return data;
}

export async function stampRegistrationAgent({ targetCollection, targetId, agentCode }) {
  if (!targetCollection || !targetId || !agentCode) return null;
  try {
    const { data } = await stampRegistrationAgentFn({ targetCollection, targetId, agentCode });
    return data;
  } catch (_) {
    return null;
  }
}

export function commercialAgentUrl(code, origin) {
  const base = origin || getPublicSiteOrigin();
  return `${base}/a/${encodeURIComponent(String(code || '').toUpperCase())}`;
}

export function agentCallableErrorMessage(error, language = 'fr') {
  const fr = language === 'fr';
  return (
    String(error?.message || '')
      .replace(/^Firebase:\s*/i, '')
      .replace(/\s*\([^)]*\)\s*$/, '') ||
    (fr ? 'Une erreur est survenue.' : 'Something went wrong.')
  );
}
